import * as React from 'react';
import { useTree } from './use-tree';

export const TreeContext = React.createContext<ReturnType<typeof useTree>>(null);

TreeContext.displayName = 'TreeContext';
